export default __webpack_public_path__ + "static/media/gura-giga-images.2101f605.png";